import React, { useState } from "react";
import {
  CustomButton2,
  CustomIcon,
  CustomView,
  TableHeader,
  TableLoading,
  TableNullData,
  UserInformation,
} from "../../../../../../../../components";

import styles from "./style.module.sass";
import values from "../../../../../../../../values";
import convertNumberToPrice from "../../../../../../../../utils/convertNumberToPrice";
import utils from "../../../../../../../../utils";
import { ALL_SERVICE_FOR_DRIVER_2 } from "../../../../../../../../values/tableHeaders";
import { useTranslation } from "react-i18next";
import api from "../../../../../../../../api";
import Context from "../../../../../../../../context";
import successHandler from "../../../../../../../../utils/successHandler";
import { ShowAllServiceModal } from "../../../..";

interface IParent {
  phoneNumber: string;
  firstName?: string;
  province?: string;
  lastName?: string;
  gender?: string;
  city?: string;
}

type Props = {
  values: IParent;
  services: Array<any>;
  onClickEdit: () => void;
  onClickCreateService: () => void;
  onClickUpdateService: (event: any) => void;
  setModal:React.Dispatch<React.SetStateAction<ShowAllServiceModal>>
};

const ShowServiceList: React.FC<Props> = (props: Props): React.ReactElement => {
  const { t } = useTranslation();

  const { selectedDriver, setShowModal,showModal } = React.useContext(
    Context.DriverScreen
  );

  const [selectedService, setSelectedService] = useState<any>(null);

  const onAddService = async (serviceId: string, driverId: string) => {
    const result = await api.put.common.addServiceToDriver({
      serviceId,
      driverId,
    });

    if (result.CODE === 2099) {
      successHandler(2010);
      setShowModal!("SHOW_ALL_SERVICE");
      props.setModal("NULL")
      console.log({showModal})

    }
  };

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <CustomView.Container className={styles.showServiceList}>
      <CustomView.Row className={styles.title}>لیست سرویس ها</CustomView.Row>
      <CustomView.Row className={styles.body}>
        <CustomView.Column medium={6}>
          <UserInformation
            name={props.values?.firstName}
            lastName={props.values?.lastName}
            phoneNumber={props.values?.phoneNumber}
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className={styles.rowRevers}>
          <CustomIcon
            icon={"fa-solid fa-plus"}
            onClick={props.onClickCreateService}
          />
          <CustomIcon icon={"fa-solid fa-pen"} onClick={props.onClickEdit} />
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row>
        <div className="table-content-wrapper">
          <table>
            <TableHeader
              headers={values.tableHeaders.ALL_SERVICE_FOR_DRIVER_2}
            />
            {props.services?.length >= 1 && (
              <>
                {/*{(allService?.data?.result?.docs?.length <= 0 ||*/}
                {/*  !allService?.data?.result?.docs) && (*/}
                {/*  <TableNullData text={t("driver_has_not_active_service")}/>*/}
                {/*)}*/}

                <tbody id="driver-table-body-container">
                  {props.services?.map((service: any, index: number) => {
                    return (
                      <tr
                        key={`driver-${index}`}
                        onClick={() => setSelectedService(service)}
                      >
                        <td>
                          <input
                            id="checkmark"
                            type="checkbox"
                            name="checkmark"
                            checked={selectedService?._id === service?._id}
                          />
                        </td>

                        <td className="pointer">
                          <UserInformation
                            avatar={service?.student?.avatar}
                            name={service?.student?.firstName}
                            lastName={service?.student?.lastName}
                            phoneNumber={service?.student?.phoneNumber}
                            isBlock={service?.student?.approved?.isApprove}
                          />
                        </td>
                        <td className="pointer">
                          <UserInformation
                            avatar={service?.school?.avatar}
                            name={service?.school?.name}
                            phoneNumber={service?.school?.telephone}
                            isBlock={service?.school?.approved}
                            hideAvatar
                          />
                        </td>
                        <td className="pointer">
                          {service?.price && (
                            <div>
                              {convertNumberToPrice(service?.price)} {"تومان"}
                            </div>
                          )}
                        </td>
                        <td>
                          {service?.expire && service?.cycle
                            ? service?.cycle -
                              (utils.remainDays(service?.expire) %
                                service?.cycle)
                            : "-"}
                        </td>
                        <td>
                          {/* Edit Icon */}
                          <CustomIcon
                            icon="fas fa-pen"
                            hoverTitle={t("update")}
                            onClick={() => props.onClickUpdateService(service)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </>
            )}
          </table>
        </div>
      </CustomView.Row>
      <CustomView.Row
        style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}
      >
        <CustomButton2
          title={t("select")}
          onClick={() => onAddService(selectedService?._id, selectedDriver?._id)}
        />
      </CustomView.Row>
    </CustomView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default ShowServiceList;
